export default __webpack_public_path__ + "static/media/audio_17_perros.2d902ade.mp3";